import { Base } from '@/components/Base';
import { Consent } from '@/components/Consent';
import { Direkt } from '@/components/Direkt';
import { Page4XX } from '@/components/Page4XX';
import { Tracking } from '@/components/Tracking';
import getConfig from 'modules/config';
import { NextPage } from 'next';

const PageDirekt: NextPage = () => {
  const { id, aId } = getConfig('direkt');

  return (
    <>
      <Consent />
      <Tracking />
      <Base content={!id || !aId ? <Page4XX status={404} /> : <Direkt />} />
    </>
  );
};

export default PageDirekt;
